import { useEffect } from "react";
import {
  WheelRaffleItemStatus,
  getWheelRaffleErrorMessage,
  raffleDetailApi,
  useGetRaffleQuery,
} from "entities/wheel-raffle";
import { RAFFLE_END_GRACE_MS, RAFFLE_POLLING_MS } from "./constants";

const { useQueryState } = raffleDetailApi.endpoints.getRaffle;

export const useRaffleDetail = (raffleId: number) => {
  // После розыгрыша данные не меняются — поллинг выключаем по кешу.
  const { data: cached } = useQueryState(raffleId);
  const isDrawn = cached?.status === WheelRaffleItemStatus.DRAWN;

  const result = useGetRaffleQuery(raffleId, {
    refetchOnMountOrArgChange: true,
    pollingInterval: isDrawn ? 0 : RAFFLE_POLLING_MS,
  });
  const { refetch } = result;
  const endsAt = result.data?.ends_at;

  // Таймер дошёл до нуля — сразу подтягиваем итоги, не дожидаясь поллинга.
  useEffect(() => {
    if (!endsAt || isDrawn) return;
    const delay = Date.parse(endsAt) - Date.now() + RAFFLE_END_GRACE_MS;
    if (delay <= 0) return;
    const timer = setTimeout(refetch, delay);
    return () => clearTimeout(timer);
  }, [endsAt, isDrawn, refetch]);

  return {
    raffle: result.data,
    isDrawn,
    isLoading: result.isLoading,
    errorMessage: getWheelRaffleErrorMessage(result.error),
  };
};
